import {Navigate} from "react-router-dom";
import Navigation from "./Navigation.jsx";
import ProfileContent from "./ProfileContent.jsx";
import LegacyProfileContent from "./LegacyProfileContent.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import MyProfilePage from '../pages/account/my-profile/MyProfilePage.jsx';
import { getSession } from "../services/session";

function Profile(props) {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let dData, bData, profileContent;
    dData = getSession();

    if (isV2 && dData.migrated) {
        profileContent = <MyProfilePage />;
    } else if (dData.migrated){
        profileContent = <ProfileContent />;
    }else{
        profileContent = <LegacyProfileContent />;
    }

    return (compareRole("", dData?.userrole || iAmHigherAuthority(0, dData?.role_weight))) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {profileContent}
        </>
    ) : <Navigate to={"/"}/>;
}

export default Profile;